<template>
    <a-menu-item :key="routeChildren.path" @click.capture="handleLink">
        <span class="anticon">
            <Vicon :icon="routeChildren.meta.icon"></Vicon>
        </span>
        <span>{{ routeChildren.meta.title }}</span>
    </a-menu-item>
</template>

<script>
import { defineComponent, ref, reactive, toRefs, onBeforeMount, onMounted, watchEffect, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Vicon from '../icon/index.vue'
import { isExternal } from '@/utils/validate'

export default defineComponent({
    name:'MenuItem',
    components:{Vicon},
    props:{
        item: {
            type: Object,
            default() {
                return null
            },
        },
        routeChildren: {
            type: Object,
            default: () => null,
        },
    },
    setup(props){
        const route = useRoute()
        const router = useRouter()
        const routePath = props.routeChildren.path
        const handleLink = () =>{
            if (route.path !== routePath) router.push(routePath)
            else router.go(0)
        }

        return {
            handleLink,
        }
    }
})
</script>
<style scoped lang='less'>
</style>